/*
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2023 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { IconProps } from "@insite/mobius/Icon";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";

type BarcodeItemStylesProps = {
    wrapper?: InjectableCss;
    barcodeWrapper?: InjectableCss;
    description?: TypographyPresentationProps;
    codeWrapper?: InjectableCss;
    lineInfoWrapper?: InjectableCss;
    lineCardFooter?: InjectableCss;
    printLogo?: IconProps;
    logoWrapper?: InjectableCss;
}

const barcodeItemStyles: BarcodeItemStylesProps = {
    wrapper: {
        css: css`
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;

            @media print {
            &.is-safari {
                    padding-top: 30px;
                }
            }
        `,
    },
    barcodeWrapper: {
        css: css`
            // border: 1px solid transparent;
            margin-bottom: 37px;
            border-radius: 10px;
            padding: 10px;
            flex-direction: column;
            align-items: center;
            height: 185px;
            width: 288px;
            overflow: hidden;
            break-inside: avoid-page;
            -webkit-break-inside: avoid;
            page-break-inside: avoid;

            display: flex;
            align-items: center;
            justify-content: center;

            @page:first {
                margin-top: 65px;
            }
            @page {
                margin-top: 110px;
            }

            @media print {
                &.is-safari {
                    margin-bottom: 18px;
                    /* These styles will only apply in Safari when printing */
                    &.start-of-next-page {
                        margin-top: 100px;
                    }
                }
            }

            &.last-boxes-in-last-page {
                margin-bottom: 0;
            }
        `,
    },
    description: {
        css: css`
            display: block;
            width: 90%;
            line-height: 10px;
            height: 25px;
            margin-bottom: 5px;
            overflow: hidden;
            text-align: center;
            white-space: pre-wrap;
        `,
    },
    lineInfoWrapper: {
        css: css`
            margin-top: 5px;
            display: flex;
            justify-content: space-between;
            width: 90%;

            > div {
                line-height: 12px;
            }
        `,
    },
    lineCardFooter: {
        css: css`
            text-align: right;
            width: 90%;
            display: inline-flex;
            justify-content: flex-end;
            align-items: center;
        `,
    },
    printLogo: {
        size: 100,
    },
    logoWrapper: {
        css: css`
            display: inline-block;
            margin-right: 25px;
        `,
    },
    codeWrapper: {
        css: css`
            display: flex;
            align-items: center;
        `,
    },
};

export default barcodeItemStyles;